export { getProductServerAction } from 'next-flight-server-reference-proxy-loader?id=404563b6c5e89541f7762535dca5f41cd43524b055&name=getProductServerAction!'